module.exports = __webpack_public_path__ + "static/img/promotion1.4f3cc96d.png";